/* GemPages' script-only sections keep gps-lazy after the native loader has
   released their resources: no deferred stylesheet emits GpLazyLoaded.
   Complete that existing lifecycle without changing the vendor components. */
(() => {
  const pending = new Map();
  let frame = 0;

  const flush = () => {
    frame = 0;
    const ready = [];
    for (const [section, observer] of pending) {
      if (!section.isConnected || !section.classList.contains('gps-lazy')) {
        observer.disconnect();
        pending.delete(section);
      } else if (!section.closest('.gps')?.querySelector('.gps-link')) {
        ready.push(section);
      }
    }
    for (const section of ready) {
      pending.get(section).disconnect();
      pending.delete(section);
      section.classList.remove('gps-lazy');
      section.dispatchEvent(new Event('GpLazyLoaded'));
    }
  };

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(flush);
  };

  for (const section of document.querySelectorAll('#MainContent .gps-lazy')) {
    const scope = section.closest('.gps');
    if (!scope) continue;
    const observer = new MutationObserver(schedule);
    pending.set(section, observer);
    observer.observe(scope, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'delay'],
    });
  }
  if (pending.size) schedule();
})();
